module.exports = __webpack_public_path__ + "img/particle_motion_00070.209f38d9.png";